'use es6';

import keyMirror from 'react-utils/keyMirror';
import PortalIdParser from 'PortalIdParser';
export const Formats = {
  CSV: 'csv',
  XLS: 'xls',
  XLSX: 'xlsx'
};
export const ExportLimits = {
  XLS: 65000,
  XLSX: 1000000
};
export const FormatValues = Object.values(Formats || {});
export const ExportStates = keyMirror({
  NOT_REQUESTED: null,
  PENDING: null,
  SUCCEEDED: null,
  FAILED: null
});
export const PreferenceState = keyMirror({
  NOT_REQUESTED: null,
  PENDING: null,
  SUCCEEDED: null,
  FAILED: null
});
export const FailureReasons = keyMirror({
  NO_NETWORK: null,
  UNBOUNCE_FAILED: null,
  BLOCKED_PORTAL: null,
  // https://private.hubteam.com/config/com.hubspot.inbounddb.io.data/InboundDbIoDataExportsConfig/PORTAL_ID_BLOCKLIST/INTEGER_SET
  FREE_PORTAL_EXPORTS_LIMIT: null,
  // https://private.hubteam.com/config/com.hubspot.inbounddb.io.data/InboundDbIoExportValidatorConfig/FREE_PORTAL_TOTAL_EXPORT_LIMIT/INTEGER
  PAID_PORTAL_EXPORTS_LIMIT: null,
  // https://private.hubteam.com/config/com.hubspot.inbounddb.io.data/InboundDbIoExportValidatorConfig/PAID_PORTAL_TOTAL_EXPORT_LIMIT/INTEGER
  UNKNOWN: null
});
export const DefaultFieldKeys = {
  EMAIL: 'email',
  FORMAT: 'format'
};
export const EmailValidationStates = keyMirror({
  VALID: null,
  INVALID: null
});
export const EmailValidationStateNames = Object.keys(EmailValidationStates);
export const ExportPreferences = {
  SEND: 'SEND',
  DO_NOT_SEND: 'DO_NOT_SEND'
};
export const Urls = {
  allowlistUrl: 'https://knowledge.hubspot.com/articles/KCS_Article/Email/What-steps-can-I-take-to-ensure-HubSpot-emails-get-delivered-to-my-inbox',
  notificationUrl: 'https://knowledge.hubspot.com/articles/kcs_article/messages/why-am-i-not-receiving-push-notifications-for-messages-in-my-browser',
  notificationCenterUrl: `/notification-preferences/${PortalIdParser.get()}`
};